import {
    ACard,
    ADataGrid,
    ADataGridColumn,
    ADataGridFilter, ASectionTitle,
    PagedSearchParams
} from "@atiautomacao/ati-ui-library";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../../Config/Hooks";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {
    DeleteAllUnavailabilityReactQuery,
    DeleteUnavailabilityReactQuery, ExportUnavailabilityReactQuery, FinalizeUnavailabilityReactQuery,
    UnavailabilityReactQuery
} from "./reactQuery/UnavailabilityReactQuery";
import IconButton from "@mui/material/IconButton";
import {
    Alert,
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Divider, Drawer,
    MenuItem, Stack,
    TextField,
    Tooltip,
    useTheme
} from "@mui/material";
import {
    CheckCircleOutlined,
    DeleteOutline, DeleteOutlined,
    EditOutlined,
    MoreHorizOutlined,
    SimCardDownloadOutlined,
    VisibilityOutlined
} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {DateFormat} from "../../../Utils/DateFormatPatternUtils";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, {Dayjs} from "dayjs";
import "dayjs/locale/pt-br";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import Menu from "@mui/material/Menu";
import SelectedMenu from "./SelectedMenu";
import {Pill} from "./Pill";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import CloseIcon from "@mui/icons-material/Close";
import FinalizeUnavailabilityDialog from "./FinalizeUnavailabilityDialog";
import {useSnackbar} from "notistack";
import UnavailabilityByPowerStationCard from "./UnavailabilityByPowerStationCard";
import UnavailabilityModeToggle from "./components/UnavailabilityModeToggle";
import UnavailabilityEmptyState from "./components/UnavailabilityEmptyState";
import {
    applyFiltersToColumns,
    buildDateFilterSanitizationMessage,
    buildDateFilterValidationMessage,
    mergePendingDateFilterInputValues,
    processDateFilters,
    validateAndConvertDateFilters,
} from "../../../Utils/AlarmDateFilterValidationUtils";
import {applyChartModeToFilters, UnavailabilityChartMode} from "./utils/UnavailabilityChartUtils";


const initColumns = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'id', condition: 'equals', value: '', sort: 'desc'}
    },
    {
        name: 'createdByType',
        label: 'Criação',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'createdByType', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'powerStationName',
        label: 'Usina',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'powerStationName', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'skidName',
        label: 'Skid',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'skidName', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'equipmentName',
        label: 'Equipamento',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'equipmentName', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'startDateTime',
        label: 'Início',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'startDateTime',
            condition: 'starts-at',
            value: '',
            sort: 'none',
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'endDateTime',
        label: 'Término',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'endDateTime',
            condition: 'starts-at',
            value: '',
            sort: 'none',
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'durationHours',
        label: 'Duração',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'durationHours', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'reason',
        label: 'Motivo',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'reason', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'type',
        label: 'DIN/DEX',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'type', condition: 'contains', value: '', sort: 'none'}
    },
    {
        name: 'energyLossKwh',
        label: 'Perda (kWh)',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'energyLossKwh', condition: 'equals', value: '', sort: 'none'}
    },
    {
        name: 'status',
        label: 'Situação',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'status', condition: 'contains', value: '', sort: 'none'}
    },
] as ADataGridColumn [];

export type ActionConfig = {
    actionName: string;
    disabled: boolean;
};

type CreatedByType = "USER" | "SYSTEM";

export interface RowUnavailability {
    id: number;
    createdByType: CreatedByType | JSX.Element;
    powerStationName: string;
    equipmentName?: string;
    skidName?: string;
    startDateTime: Date | string;
    endDateTime?: Date | string;
    durationHours?: string;
    description: string;
    type: string | JSX.Element;
    energyLossKwh: string;
    status: string | JSX.Element;
    reason: string;
    actionsConfig?: Array<ActionConfig>
}

const MAX_RANGE_DAYS = 180;

function prioritizeReasonSort(filters: ADataGridFilter[]): ADataGridFilter[] {
    const reasonSortIndex = filters.findIndex(
        ({name, sort}) => name === 'reason' && (sort === 'asc' || sort === 'desc')
    );

    if (reasonSortIndex <= 0) {
        return filters;
    }

    return [
        filters[reasonSortIndex],
        ...filters.slice(0, reasonSortIndex),
        ...filters.slice(reasonSortIndex + 1),
    ];
}

function validateDateRange(
    start: Dayjs | null,
    end: Dayjs | null,
    changedField: 'start' | 'end',
    maxRangeDays: number = MAX_RANGE_DAYS,
): string | null {
    if (!start?.isValid() || !end?.isValid()) {
        return null;
    }

    const diffDays = end.diff(start, 'day');

    if (diffDays < 0) {
        return changedField === 'start'
            ? 'A data inicial não pode ser maior que a data final.'
            : 'A data final não pode ser menor que a data inicial.';
    }

    if (diffDays > maxRangeDays) {
        return `O período máximo permitido é de ${maxRangeDays} dias.`;
    }

    return null;
}


export default function UnavailabilityPage(){
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const account = useAppSelector(state => state.authentication.account);
    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50));
    const [columns, setColumns] = useState(() => initColumns);
    // Sem persistência: ao voltar para a tela, o gráfico sempre abre em "Totais".
    const [chartMode, setChartMode] = useState<UnavailabilityChartMode>('TOTAL');

    // Filtros enviados ao backend: no modo DIN o grid mostra somente registros DIN.
    const effectiveSearchParams = useMemo(() => {
        if (chartMode === 'TOTAL') return pagedSearchParams;
        return new PagedSearchParams(
            applyChartModeToFilters(pagedSearchParams.filters, chartMode),
            pagedSearchParams.page,
            pagedSearchParams.size
        );
    }, [pagedSearchParams, chartMode]);

    const handleChartModeChange = useCallback((mode: UnavailabilityChartMode) => {
        setChartMode(mode);
        // A quantidade de registros muda com o modo; volta para a primeira página.
        setPagedSearchParams(current => new PagedSearchParams(current.filters, 0, current.size));
    }, []);

    const [rangeStart, setRangeStart] = useState<Dayjs | null>(dayjs().subtract(30, 'day'));
    const [rangeEnd, setRangeEnd] = useState<Dayjs | null>(dayjs());

    const handleRangeStartChange = (newValue: Dayjs | null) => {
        if (!newValue || !newValue.isValid()) {
            enqueueSnackbar("Informe uma data válida no campo Início.", { variant: 'error' });
            return;
        }

        const error = validateDateRange(newValue, rangeEnd, 'start');
        if (error) {
            enqueueSnackbar(error, { variant: 'warning' });
            return;
        }
        setRangeStart(newValue);
    };

    const handleRangeEndChange = (newValue: Dayjs | null) => {
        if (!newValue || !newValue.isValid()) {
            enqueueSnackbar("Informe uma data válida no campo Término.", { variant: 'error' });
            return;
        }

        const error = validateDateRange(rangeStart, newValue, 'end');
        if (error) {
            enqueueSnackbar(error, { variant: 'warning' });
            return;
        }
        setRangeEnd(newValue);
    };

    const rangeStartISO = rangeStart?.isValid() ? rangeStart.startOf("day").format("YYYY-MM-DDTHH:mm:ss") : null;
    const rangeEndISO = rangeEnd?.isValid() ? rangeEnd.endOf("day").format("YYYY-MM-DDTHH:mm:ss") : null;

    const { data, isSuccess } = UnavailabilityReactQuery(effectiveSearchParams, rangeStartISO, rangeEndISO);
    const [selectedToDelete, setSelectedToDelete] = useState<any>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const mutationDelete = DeleteUnavailabilityReactQuery(pagedSearchParams);
    const mutationAllDelete = DeleteAllUnavailabilityReactQuery(pagedSearchParams);
    const [totalOfRecords, setTotalOfRecords] = useState(0);
    const [rows, setRows] = useState<Array<RowUnavailability>>([]);
    const [selectedRows, setSelectedRows] = useState<RowUnavailability[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [clearSelection, setClearSelection] = useState(false);
    // bulk delete
    const [openBulkDeleteDialog, setOpenBulkDeleteDialog] = useState(false);

    useEffect(() => {
        if (clearSelection) {
            setClearSelection(false);
        }
    }, [clearSelection]);

    const [detailsOpen, setDetailsOpen] = useState(false);
    const [detailsRow, setDetailsRow] = useState<any>(null);
    const mutationFinalize = FinalizeUnavailabilityReactQuery(pagedSearchParams);
    const mutationExport = ExportUnavailabilityReactQuery();

    const validateCurrentPeriod = (): boolean => {
        const validationResult = validateAndConvertDateFilters([
            {name: "startDateTime", condition: "starts-at", value: rangeStartISO || "", sort: "none"},
            {name: "endDateTime", condition: "ends-at", value: rangeEndISO || "", sort: "none"},
        ]);

        if (!rangeStartISO || !rangeEndISO || !validationResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(validationResult.invalidFieldLabels), {variant: 'error'});
            return false;
        }

        return true;
    };

    const getValidatedExportGridParams = (): PagedSearchParams | null => {
        const currentFilters = mergePendingDateFilterInputValues(
            "settings-grid-alarm-severity",
            extractFiltersFromColumns(columns),
            columns
        );
        const processedResult = processDateFilters(currentFilters);

        if (processedResult.wasSanitized) {
            setColumns(applyFiltersToColumns(initColumns, processedResult.filters));
            enqueueSnackbar(buildDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels), {variant: 'warning'});
            return null;
        }

        if (!processedResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(processedResult.invalidFieldLabels), {variant: 'error'});
            return null;
        }

        return new PagedSearchParams(
            applyChartModeToFilters(processedResult.convertedFilters, chartMode),
            pagedSearchParams.page,
            pagedSearchParams.size
        );
    };

    const handleExport = (format: "csv" | "excel") => {
        const exportPagedSearchParams = getValidatedExportGridParams();
        if (!exportPagedSearchParams) return;
        if (!validateCurrentPeriod()) return;

        mutationExport.mutate({
            format,
            pagedSearchParams: exportPagedSearchParams,
            rangeStart: rangeStartISO,
            rangeEnd: rangeEndISO,
        });
    };

    const [openFinalizeBulk, setOpenFinalizeBulk] = useState(false);
    const [openFinalizeSingle, setOpenFinalizeSingle] = useState(false);
    const [singleFinalizeId, setSingleFinalizeId] = useState<number | null>(null);

    const handleOpenFinalizeBulk = () => setOpenFinalizeBulk(true);
    const handleCloseFinalizeBulk = () => setOpenFinalizeBulk(false);

    const handleOpenFinalizeSingle = (row: any) => {
        setSingleFinalizeId(Number(row?.id));
        setOpenFinalizeSingle(true);
    };
    const handleCloseFinalizeSingle = () => {
        setSingleFinalizeId(null);
        setOpenFinalizeSingle(false);
    };

    // confirma bulk
    const handleConfirmFinalizeBulk = (endDateTimeIsoOrNull: string | null) => {
        mutationFinalize.mutate(
            { idList: selectedIds, endDateTime: endDateTimeIsoOrNull },
            {
                onSuccess: () => {
                    setSelectedRows([]);
                    setSelectedIds([]);
                    setClearSelection(true);
                    setOpenFinalizeBulk(false);
                }
            }
        );
    };

    // confirma single
    const handleConfirmFinalizeSingle = (endDateTimeIsoOrNull: string | null) => {
        if (!singleFinalizeId) return;

        mutationFinalize.mutate(
            { idList: [singleFinalizeId], endDateTime: endDateTimeIsoOrNull },
            { onSuccess: () => handleCloseFinalizeSingle() }
        );
    };

    const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<RowUnavailability | null>(null);

    const lastMousePosRef = useRef<{ x: number; y: number }>({ x: 0, y: 0 });
    function handleMouseMoveInGrid(e: React.MouseEvent<HTMLDivElement>) {
        lastMousePosRef.current = { x: e.clientX, y: e.clientY };
    }

    const rawRowsByIdRef = useRef<Record<number, any>>({});

    function getCreatedByLabel(createdByType: any): string {
        // quando é pill: createdByType.props.label
        const label = createdByType?.props?.label;
        return String(label ?? createdByType ?? "").trim().toLowerCase();
    }

    function isUserRow(row: any): boolean {
        const label = getCreatedByLabel(row?.createdByType);
        // cobre "Usuário" e "USER"
        return label === "usuário" || label === "usuario" || label === "user";
    }


    function handleActionsUnavailability(value: any) {
        console.log("Editar indisponibilidade:", value);
        setSelectedRow(value);

        const { x, y } = lastMousePosRef.current;
        setMenuPos({ left: x, top: y });
    }

    function handleCloseActionsMenu() {
        setMenuPos(null);
        setSelectedRow(null);
    }

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        const processedResult = processDateFilters(prioritizeReasonSort(dataGridFilters));

        if (processedResult.wasSanitized) {
            setColumns(applyFiltersToColumns(initColumns, processedResult.filters));
            enqueueSnackbar(buildDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels), {variant: 'warning'});
            return;
        }

        if (!processedResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(processedResult.invalidFieldLabels), {variant: 'error'});
            return;
        }

        setPagedSearchParams(new PagedSearchParams(processedResult.convertedFilters, page, pageSize));
    }, [enqueueSnackbar]);

    function formatDurationHours(durationHours: unknown): string {
        if (durationHours === null || durationHours === undefined || durationHours === "") return "-";

        const hours = Number(durationHours);
        if (!Number.isFinite(hours) || hours < 0) return "-";

        const totalSeconds = Math.floor(hours * 3600);

        const hh = Math.floor(totalSeconds / 3600);
        const mm = Math.floor((totalSeconds % 3600) / 60);
        const ss = totalSeconds % 60;

        const pad = (n: number) => String(n).padStart(2, "0");
        return `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
    }



    function renderCreatedByType(value: CreatedByType): JSX.Element | string {
        const v = String(value ?? "").toUpperCase();

        if (v === "SYSTEM") return <Pill label="Sistema" tone="systemBlue" />;
        if (v === "USER") return <Pill label="Usuário" tone="userOrange" />;
        return String(value ?? "-");
    }

    function renderType(value: unknown): JSX.Element | string {
        const raw = String(value ?? "").trim();
        const v = raw.toUpperCase();

        if (v === "DIN") return <Pill label="DIN" tone="dinBlue" />;
        if (v === "DEX") return <Pill label="DEX" tone="dexGreen" />;

        // futuro: mantém pill neutro, mas mostra o texto
        return <Pill label={raw || "-"} tone="neutral" />;
    }

    function normalizeStatus(raw: string) {
        // protege contra variações tipo "Em Aberto", "EM ABERTO", "em aberto"
        return raw.trim().toUpperCase().replace(/\s+/g, " ");
    }

    function renderStatus(value: unknown): JSX.Element | string {
        const raw = String(value ?? "");
        const v = normalizeStatus(raw);

        if (v === "EM ABERTO") return <Pill label="Em aberto" tone="openOrange" />;
        if (v === "FINALIZADO") return <Pill label="Finalizado" tone="doneGreen" />;

        return <Pill label={raw.trim() || "-"} tone="neutral" />;
    }


    function renderEnergyLoss(value: unknown): string {
        if (value === null || value === undefined || value === "") {
            return "-";
        }

        // garante que não vem "kWh" duplicado
        const raw = String(value).replace(/\s*kwh$/i, "").trim();

        return `${raw} kWh`;
    }

    const handleDeleteUnavailability = useCallback((data: any) => {
        setSelectedToDelete(data.id);
        setOpenDialog(true);
    },[]);

    const handleDialogToggle = () => {
        setOpenDialog(!openDialog);
    }
    const handleDialogConfirm = async () => {
        mutationDelete.mutate({ id: selectedToDelete, pagedSearchParams });
        setSelectedToDelete(null);
        handleDialogToggle();
    }

    const handleDialogClose = () => {
        setSelectedToDelete(null);
        handleDialogToggle();
    }

    function handleOnRowSelect(selectedRows: any[]) {


        const rows = Array.isArray(selectedRows) ? selectedRows : [];

        setSelectedRows(rows);

        const ids = rows
            .map((r) => Number(r?.id))
            .filter((id) => Number.isFinite(id));

        setSelectedIds(ids);

        console.log("Selected IDs:", ids);
    }

    const selectedCount = selectedRows.length;

    const userSelectedCount = useMemo(() => {
        return selectedRows.filter(isUserRow).length;
    }, [selectedRows]);


    // for finalize or delete in bulk
    const canBulkAction = selectedCount > 1 && userSelectedCount === selectedCount;

    const isEmptyGrid = isSuccess && totalOfRecords === 0;

    useEffect(() => {
        if (!isSuccess) return;

        setTotalOfRecords(data?.totalOfRecords ?? 0);
        rawRowsByIdRef.current = {};
        const unavailabilityRows = (data?.data ?? []).map((item: any) => {
            rawRowsByIdRef.current[item.id] = item;
            return {
                id: item.id,
                createdByType: renderCreatedByType(item.createdByType),
                powerStationName: item.powerStationName,
                equipmentName: item.equipmentName,
                skidName: item.skidName,
                startDateTime: DateFormat(item.startDateTime),
                endDateTime: item.endDateTime ? DateFormat(item.endDateTime) : null,
                durationHours: formatDurationHours(item.durationHours),
                description: item.description,
                type: renderType(item.type),
                energyLossKwh: renderEnergyLoss(item.energyLossKwh),
                status: renderStatus(item.status),
                reason: item.reason,
                actionsConfig: [{actionName: "edit", disabled: false}]
            };
        });
        setRows(unavailabilityRows);
    }, [data?.data]);


    const handleEditUnavailability = useCallback((data: any) => {
        navigate(SystemRoutes.DASHBOARD_OVERVIEW_UNAVAILABILITY_FORM, {state: {id: data.id}});
    }, [navigate]);

    useEffect(() => {
        if(mutationDelete.isSuccess || mutationAllDelete.isSuccess) {
            setPagedSearchParams(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50))
        }

    }, [mutationDelete.isSuccess, mutationAllDelete.isSuccess]);



    const handleOpenBulkDeleteDialog = useCallback(() => {
        if (!canBulkAction) return;
        setOpenBulkDeleteDialog(true);
    }, [canBulkAction]);

    const handleCloseBulkDeleteDialog = useCallback(() => {
        setOpenBulkDeleteDialog(false);
    }, []);

    const handleConfirmBulkDelete = useCallback(() => {
        if (!selectedIds?.length) return;

        mutationAllDelete.mutate(selectedIds, {
            onSuccess: () => {
                // limpa seleção local após excluir
                setSelectedRows([]);
                setSelectedIds([]);
                setClearSelection(true);
                setOpenBulkDeleteDialog(false);
            },
            onError: () => {
                // se der erro, mantém seleção pra usuário tentar de novo
                setOpenBulkDeleteDialog(false);
            }
        });
    }, [mutationAllDelete, selectedIds]);


    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 2,
                    mb: 1,
                    ml: 3
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <ASectionTitle
                        titleLabel="Indisponibilidade de Equipamentos"
                        styleContainer={{ padding: '0' }}
                        styleSubtitle={{marginBottom: 0, marginTop: 0}}
                        styleContainerTitle={{paddingBottom: 0}}
                        contentChildrenStyle={{ height: 20, alignItems: "flex-end" }}
                        subTitleLabel="Verifique eventos de indisponibilidade relacionados a usina"
                        contentChildren={
                            <Button
                                variant="contained"
                                startIcon={<AddCircleOutlineOutlinedIcon />}
                                sx={{
                                    height: 32,
                                    borderRadius: 1,
                                    textTransform: "uppercase",
                                    fontSize: 15,
                                    fontWeight: 500,
                                    px: 2,
                                    boxShadow: "none",
                                    mt: 0,
                                    mb: 0.5,
                                    flexShrink: 0,
                                    whiteSpace: "nowrap",
                                    minWidth: 260,
                                }}
                                onClick={() => {
                                    handleEditUnavailability(
                                        selectedRow !== undefined && selectedRow !== null ? selectedRow : { id: 0 }
                                    );
                                }}
                            >
                                Inserir registro manualmente
                            </Button>
                        }
                    />
                </Box>


            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 2,
                    ml: 3,
                    mr: 3,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                }}
            >
                <Alert
                    icon={<InfoOutlined fontSize="small" />}
                    severity="info"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        borderRadius: 1,
                        py: 0.75,
                        "& .MuiAlert-message": {
                            fontSize: 14,
                            lineHeight: "18px",
                        },
                    }}
                >
                    Atenção, dados inseridos manualmente podem estar duplicados ou não estar de acordo com a veracidade das informações
                    apresentadas. Para verificar informações validadas pelo sistema, filtre por &quot;Criação - Sistema&quot;.
                    Informações originadas pelo sistema não podem ser editadas, excluídas ou finalizadas.
                </Alert>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexShrink: 0 }}>
                        <UnavailabilityModeToggle value={chartMode} onChange={handleChartModeChange}/>
                        <DatePicker
                            label="Início"
                            inputFormat="DD/MM/YYYY"
                            value={rangeStart}
                            onChange={handleRangeStartChange}
                            renderInput={(params: any) => <TextField size="small" sx={{ width: 170 }} {...params} />}
                        />
                        <DatePicker
                            label="Término"
                            inputFormat="DD/MM/YYYY"
                            value={rangeEnd}
                            onChange={handleRangeEndChange}
                            renderInput={(params: any) => <TextField size="small" sx={{ width: 170 }} {...params} />}
                        />
                    </Stack>
                </LocalizationProvider>
            </Box>
            <Box sx={{marginBottom: 1}}>
                <UnavailabilityByPowerStationCard
                    startDateTime={rangeStartISO || ""}
                    endDateTime={rangeEndISO || ""}
                    chartMode={chartMode}
                    onChartModeChange={handleChartModeChange}
                />
            </Box>
            <Box
                onMouseMove={handleMouseMoveInGrid}
            >
                <ACard>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2,
                            py: 1.25,
                            borderBottom: "1px solid",
                            borderColor: "divider",
                        }}
                    >
                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "text.secondary" }}>
                            {selectedCount} itens selecionados
                        </Typography>

                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="text"
                                size="medium"
                                endIcon={<DeleteOutlined fontSize="medium" />}
                                disabled={!canBulkAction}
                                onClick={handleOpenBulkDeleteDialog}
                            >
                                EXCLUIR
                            </Button>

                            <Button
                                variant="text"
                                size="medium"
                                endIcon={<CheckCircleOutlined fontSize="medium" />}
                                disabled={!canBulkAction}
                                onClick={handleOpenFinalizeBulk}
                            >
                                FINALIZAR
                            </Button>
                        </Stack>
                    </Box>
                    <Box sx={{ position: "relative" }}>
                        <ADataGrid
                            ariaLabel={"settings-grid-alarm-severity"}
                            hideFilters={false}
                            showFilterOptions={false}
                            hideSelection={false}
                            onClearSelectedTempRows={clearSelection}
                            columns={columns}
                            rows={rows}
                            page={pagedSearchParams?.page}
                            disableActionsHeaderIcons={true}
                            rowsPerPage={pagedSearchParams?.size}
                            loading={false}
                            totalOfRecords={totalOfRecords}
                            disablePagination={isEmptyGrid}
                            onRowSelect={handleOnRowSelect}
                            onFiltersChange={handleOnFiltersChange}
                            actions={<>
                                <span></span>
                                <IconButton name="edit"
                                            size={"small"}
                                            aria-label="Edit"
                                            // onPointerDown={(event) => captureMenuPosition(event)}
                                            onClick={(value) => handleActionsUnavailability(value)}
                                >
                                    <Tooltip title="Opções">
                                        <MoreHorizOutlined/>
                                    </Tooltip>
                                </IconButton>
                            </>}/>
                        {isEmptyGrid && <UnavailabilityEmptyState/>}
                        <Box
                            sx={{
                                position: "absolute",
                                left: 16,
                                bottom: 6,
                                display: "flex",
                                gap: 1,
                                zIndex: 1,
                            }}
                        >
                            <Button
                                size="medium"
                                variant="text"
                                startIcon={<SimCardDownloadOutlined fontSize="large" />}
                                onClick={() => handleExport("csv")}
                                disabled={mutationExport.isLoading || totalOfRecords === 0}
                            >
                                CSV
                            </Button>
                            <Button
                                size="medium"
                                variant="text"
                                startIcon={<SimCardDownloadOutlined fontSize="large" />}
                                onClick={() => handleExport("excel")}
                                disabled={mutationExport.isLoading || totalOfRecords === 0}
                            >
                                Excel
                            </Button>
                        </Box>
                    </Box>

                    <Menu
                        open={Boolean(menuPos && selectedRow)}
                        onClose={handleCloseActionsMenu}
                        anchorReference="anchorPosition"
                        anchorPosition={menuPos ? { top: menuPos.top, left: menuPos.left } : undefined}
                        PaperProps={{
                            sx: {
                                borderRadius: 1,
                                minWidth: 220,
                                boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
                                overflow: "hidden",
                                mt: 1, // 👈 empurra mais pra baixo (opcional)
                            },
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();

                                if (!selectedRow) return;

                                const raw = rawRowsByIdRef.current[selectedRow.id];
                                console.log("RAW para detalhes:", raw);
                                setDetailsRow(raw);
                                setDetailsOpen(true);
                                console.log("Detalhes", selectedRow);
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Detalhes" icon={<VisibilityOutlined fontSize="small" />} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                handleEditUnavailability(selectedRow)
                                console.log("Editar", selectedRow);
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Editar" icon={<EditOutlined fontSize="small" />} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                console.log("Finalizar", selectedRow);
                                handleOpenFinalizeSingle(selectedRow);
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Finalizar" icon={<CheckCircleOutlined fontSize="small" />} />
                        </MenuItem>

                        <Divider />

                        <MenuItem
                            onClick={() => {
                                handleCloseActionsMenu();
                                handleDeleteUnavailability(selectedRow)
                                console.log("Excluir", selectedRow);
                            }}
                            sx={{ py: 1.25 }}
                        >
                            <SelectedMenu label="Excluir" icon={<DeleteOutlined fontSize="small" />} danger />
                        </MenuItem>
                    </Menu>
                    <Drawer
                        anchor="right"
                        open={detailsOpen}
                        onClose={() => setDetailsOpen(false)}
                        sx={{
                            zIndex: (theme) => theme.zIndex.modal + 2, // força ficar acima da topbar
                        }}
                        PaperProps={{
                            sx: {
                                width: { xs: "100%", sm: 480 }, // sidebar responsivo
                                borderTopLeftRadius: 12,
                                borderBottomLeftRadius: 12,
                            },
                        }}
                    >
                        <Box sx={{ px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Typography sx={{ fontWeight: 500, fontSize: 24 }}>Detalhes</Typography>

                            <IconButton onClick={() => setDetailsOpen(false)} size="small">
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        <Divider />

                        {/* Body (reaproveita seu conteúdo do DialogContent) */}
                        <Box sx={{ px: 2.5, py: 2 }}>
                            <Typography sx={{ fontWeight: 500, mb: 1, fontSize: 20 }}>Informações Gerais</Typography>

                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "120px 1fr",
                                    rowGap: 1,
                                    columnGap: 2,
                                    mb: 2,
                                    "& .label": { color: "text.secondary", fontSize: 14 },
                                    "& .value": { fontSize: 14, fontWeight: 600, textAlign: "right" },
                                }}
                            >
                                <Typography className="label">ID</Typography>
                                <Typography className="value">{detailsRow?.id ?? "-"}</Typography>

                                <Typography className="label">Criação</Typography>
                                <Typography className="value">{detailsRow?.createdByType ?? "-"}</Typography>

                                <Typography className="label">Usina</Typography>
                                <Typography className="value">{detailsRow?.powerStationName ?? "-"}</Typography>

                                <Typography className="label">Skid</Typography>
                                <Typography className="value">{detailsRow?.skidName ?? "-"}</Typography>

                                <Typography className="label">Equipamento</Typography>
                                <Typography className="value">{detailsRow?.equipmentName ?? "-"}</Typography>

                                <Typography className="label">Início</Typography>
                                <Typography className="value">
                                    {detailsRow?.startDateTime ? DateFormat(detailsRow?.startDateTime) : "-"}
                                </Typography>

                                <Typography className="label">Término</Typography>
                                <Typography className="value">
                                    {detailsRow?.endDateTime ? DateFormat(detailsRow?.endDateTime) : "-"}
                                </Typography>

                                <Typography className="label">Duração</Typography>
                                <Typography className="value">
                                    {detailsRow?.durationHours ? formatDurationHours(detailsRow?.durationHours) : "-"}
                                </Typography>

                                <Typography className="label">DIN/DEX</Typography>
                                <Typography className="value">{detailsRow?.type ?? "-"}</Typography>

                                <Typography className="label">Motivo</Typography>
                                <Typography className="value">{detailsRow?.reason ?? "-"}</Typography>

                                <Typography className="label">Perda Energética</Typography>
                                <Typography className="value">{renderEnergyLoss(detailsRow?.energyLossKwh) ?? "-"}</Typography>

                                <Typography className="label">Situação</Typography>
                                <Typography className="value">{detailsRow?.status ?? "-"}</Typography>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            <Typography sx={{ fontWeight: 500, mb: 1, fontSize: 20 }}>Descrição</Typography>

                            <Box
                                sx={{
                                    border: "1px solid",
                                    borderColor: "divider",
                                    borderRadius: 1,
                                    p: 1.5,
                                    fontSize: 12,
                                    minHeight: 72,
                                    mb: 2,
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {detailsRow?.description ?? "-"}
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => setDetailsOpen(false)}
                                sx={{ borderRadius: 1, fontWeight: 800 }}
                            >
                                VOLTAR
                            </Button>
                        </Box>
                    </Drawer>
                    <Dialog
                        open={openDialog}
                        onClose={handleDialogClose}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{
                            sx: {
                                borderRadius: 2,
                                boxShadow: "0px 10px 30px rgba(0,0,0,0.12)",
                            },
                        }}
                    >
                        <DialogContent sx={{ pt: 2.25 }}>
                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                {/* Ícone */}
                                <Box
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "primary.main",
                                        mt: 0.25,
                                    }}
                                >
                                    <DeleteOutline fontSize="small" />
                                </Box>

                                {/* Textos */}
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 500, fontSize: 20, mb: 0.5 }}>
                                        Tem certeza que deseja excluir essa indisponibilidade?
                                    </Typography>

                                    <Typography sx={{ fontSize: 16, color: "text.secondary", lineHeight: "18px" }}>
                                        Essa ação encerrará a visualização dessa indisponibilidade no sistema, certifique-se de que o
                                        evento não requer mais acompanhamento técnico.
                                    </Typography>
                                </Box>
                            </Stack>
                        </DialogContent>

                        <DialogActions sx={{ px: 3, pb: 2.25 }}>
                            <Button
                                variant="text"
                                onClick={handleDialogClose}
                                sx={{ textTransform: "uppercase", fontWeight: 700, fontSize: 11 }}
                            >
                                CANCELAR
                            </Button>

                            <Button
                                variant="contained"
                                onClick={handleDialogConfirm}
                                sx={{ textTransform: "uppercase", fontWeight: 800, fontSize: 11, px: 2 }}
                                disabled={!selectedToDelete}
                            >
                                EXCLUIR INDISPONIBILIDADE
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openBulkDeleteDialog}
                        onClose={handleCloseBulkDeleteDialog}
                        fullWidth
                        maxWidth="sm"
                        PaperProps={{
                            sx: {
                                borderRadius: 2,
                                px: 1,
                            }
                        }}
                    >
                        <DialogContent sx={{ pt: 2.5 }}>
                            <Stack direction="row" spacing={1.5} alignItems="flex-start">

                                <Box>
                                    <Typography sx={{ fontWeight: 700, fontSize: 20 }}>
                                        Tem certeza que deseja excluir as indisponibilidades selecionadas?
                                    </Typography>

                                    <Typography sx={{ mt: 1, fontSize: 16, color: "text.secondary", lineHeight: "18px" }}>
                                        Essa ação encerrará a visualização dessa indisponibilidade no sistema, certifique-se de que o evento não requer
                                        mais acompanhamento técnico.
                                    </Typography>
                                </Box>
                            </Stack>
                        </DialogContent>

                        <DialogActions sx={{ px: 3, pb: 2.5 }}>
                            <Button
                                variant="text"
                                onClick={handleCloseBulkDeleteDialog}
                                sx={{ fontWeight: 700 }}
                            >
                                CANCELAR
                            </Button>

                            <Button
                                variant="contained"
                                onClick={handleConfirmBulkDelete}
                                disabled={!selectedIds.length}
                                sx={{ fontWeight: 800 }}
                            >
                                EXCLUIR INDISPONIBILIDADES
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <FinalizeUnavailabilityDialog
                        open={openFinalizeSingle}
                        onClose={handleCloseFinalizeSingle}
                        onConfirm={handleConfirmFinalizeSingle}
                        mode="single"
                        selectedCount={1}
                    />

                    <FinalizeUnavailabilityDialog
                        open={openFinalizeBulk}
                        onClose={handleCloseFinalizeBulk}
                        onConfirm={handleConfirmFinalizeBulk}
                        mode="bulk"
                        selectedCount={selectedIds.length}
                    />

                </ACard>
            </Box>
        </>
    );
}
